import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {tween, combine} from 'react-imation';
import {translateX, translateY} from 'react-imation/tween-value-factories';

export default class PromoParallax extends Component {

  constructor(props){
    super(props);
  }

    componentDidMount () {

        this.containerHeight = ReactDOM.findDOMNode(this.refs.container).clientHeight;
        this.containerWidth = ReactDOM.findDOMNode(this.refs.container).clientWidth;
    }


    componentWillUpdate () {

        this.containerHeight = ReactDOM.findDOMNode(this.refs.container).clientHeight;
        this.containerWidth = ReactDOM.findDOMNode(this.refs.container).clientWidth;
    }

  render() {
    const {
        cursorPosition: {
            x = 0,
            y = 0,
            isOutside = true
        } = {}
    } = this.props;


    return (
        <div className="parallax" ref="container">

            <div className="parallax__container"
                 style={tween(y, [
                          [  0, { transform: translateY(50) } ],
                          [ this.containerHeight, { transform: translateY(-50) } ]
                      ])}
            >
                <div className="parallax__elem parallax__cake1"
                     style={tween(x, [
                              [  0, { transform: translateX(100) } ],
                              [ this.containerWidth, { transform: translateX(-100) } ]
                          ])}
                >
                </div>
                {false &&
                    <div style={{position: 'absolute', top: "200px", left: '200px'}}>
                        {`x: ${x}`}<br />
                        {`y: ${y}`}<br />
                        {this.containerHeight}<br />
                        {this.containerWidth}<br />
                    </div>
                }
            </div>


            <div className="parallax__container"
                 style={tween(y, [
                          [  0, { transform: translateY(40) } ],
                          [ this.containerHeight, { transform: translateY(-40) } ]
                      ])}
            >
                <div className="parallax__elem parallax__confetti1"
                     style={tween(x, [
                              [  0, { transform: translateX(80) } ],
                              [ this.containerWidth, { transform: translateX(-80) } ]
                          ])}
                ></div>
            </div>


            <div className="parallax__container"
                 style={tween(y, [
                          [  0, { transform: translateY(30) } ],
                          [ this.containerHeight, { transform: translateY(-30) } ]
                      ])}
            >
                <div className="parallax__elem parallax__caps1"
                     style={tween(x, [
                              [  0, { transform: translateX(60) } ],
                              [ this.containerWidth, { transform: translateX(-60) } ]
                          ])}
                ></div>
            </div>


            <div className="parallax__container"
                 style={tween(y, [
                          [  0, { transform: translateY(25) } ],
                          [ this.containerHeight, { transform: translateY(-25) } ]
                      ])}
            >
                <div className="parallax__elem parallax__cake2"
                     style={tween(x, [
                              [  0, { transform: translateX(45) } ],
                              [ this.containerWidth, { transform: translateX(-45) } ]
                          ])}
                ></div>
            </div>


            <div className="parallax__container"
                 style={tween(y, [
                          [  0, { transform: translateY(22) } ],
                          [ this.containerHeight, { transform: translateY(-22) } ]
                      ])}
            >
                <div className="parallax__elem parallax__caps2"
                     style={tween(x, [
                              [  0, { transform: translateX(40) } ],
                              [ this.containerWidth, { transform: translateX(-40) } ]
                          ])}
                ></div>
            </div>


            <div className="parallax__container"
                 style={tween(y, [
                          [  0, { transform: translateY(18) } ],
                          [ this.containerHeight, { transform: translateY(-18) } ]
                      ])}
            >
                <div className="parallax__elem parallax__confetti2"
                     style={tween(x, [
                              [  0, { transform: translateX(35) } ],
                              [ this.containerWidth, { transform: translateX(-35) } ]
                          ])}
                ></div>
            </div>


            <div className="parallax__container"
                 style={tween(y, [
                          [  0, { transform: translateY(15) } ],
                          [ this.containerHeight, { transform: translateY(-15) } ]
                      ])}
            >
                <div className="parallax__elem parallax__logo"
                     style={tween(x, [
                              [  0, { transform: translateX(25) } ],
                              [ this.containerWidth, { transform: translateX(-25) } ]
                          ])}
                ></div>
            </div>


            <div className="parallax__container"
                 style={tween(y, [
                          [  0, { transform: translateY(10) } ],
                          [ this.containerHeight, { transform: translateY(-10) } ]
                      ])}
            >
                <div className="parallax__elem parallax__spots1"
                     style={tween(x, [
                              [  0, { transform: translateX(12) } ],
                              [ this.containerWidth, { transform: translateX(-12) } ]
                          ])}
                ></div>
            </div>


            <div className="parallax__container"
                 style={tween(y, [
                          [  0, { transform: translateY(7) } ],
                          [ this.containerHeight, { transform: translateY(-7) } ]
                      ])}
            >
                <div className="parallax__elem parallax__spots2"
                     style={tween(x, [
                              [  0, { transform: translateX(10) } ],
                              [ this.containerWidth, { transform: translateX(-10) } ]
                          ])}
                ></div>
            </div>
        </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/common/components/wiget/PromoParallax.js